import { ref } from 'vue'

import { defineStore } from 'pinia'

import * as aggr from '@/api-generator/aggr/index'
import { feCompaniesAPI } from '@/APIs'

export const useFECompanyStore = defineStore('FEcompany', () => {
  const $reset = () => {}

  const companySubscription = ref<aggr.CompanySubscriptionType>(aggr.CompanySubscriptionType.Trial)
  const setCompanySubPlan = (plan: aggr.CompanySubscriptionType) => {
    companySubscription.value = plan
  }

  const isFeCompanyOrgLoading = ref(true)
  const setFeCompanyOrgLoading = (status: boolean) => {
    isFeCompanyOrgLoading.value = status
  }

  const companyPlanFeatures = ref<aggr.EFCompanyFeatureRs[]>([])
  const setCompanyPlanFeatures = (features: aggr.EFCompanyFeatureRs[]) => {
    companyPlanFeatures.value = features
  }

  // 取得公司訂閱方案權限
  const handleGetCompanyPlanFeatures = async (companyUuid: string) => {
    try {
      const { data } = await feCompaniesAPI.getCompanyPlanFeatures(companyUuid)
      setCompanyPlanFeatures(data)
    } catch (error: any) {
      console.error(error)
    }
  }

  // 公司組織清單
  const feOrganizations = ref<aggr.EFCompanyOrganizationRs | null>(null)

  const handleGetOrganizations = async (companyUuid: string) => {
    try {
      const { data } = await feCompaniesAPI.getOrganizationsByCompanyId(companyUuid)
      feOrganizations.value = data
      return true
    } catch (error: any) {
      console.error(error)
      return false
    } finally {
      setFeCompanyOrgLoading(false)
    }
  }

  return {
    $reset,
    companySubscription,
    setCompanySubPlan,
    setFeCompanyOrgLoading,
    isFeCompanyOrgLoading,
    companyPlanFeatures,
    setCompanyPlanFeatures,
    handleGetCompanyPlanFeatures,
    feOrganizations,
    handleGetOrganizations
  }
})
